import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/hero/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { Problems } from './components/sections/Problems';
import { Solution } from './components/sections/Solution';
import { CoreContent } from './components/sections/CoreContent';
import { InsidePreview } from './components/preview/InsidePreview';
import { Bonuses } from './components/bonuses/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalComparison } from './components/sections/FinalComparison';
import { Footer } from './components/layout/Footer';
import { StickyBar } from './components/layout/StickyBar';
import { initMetaPixel, OFFER_PIXEL_PARAMS, trackPixel } from './utils/metaPixel';
const PAGE_TITLE = 'Handball Class Ready — 12 Ready-to-Teach School Handball Lessons for Ages 8–11';
const PAGE_DESCRIPTION = 'A 40-page visual PDF guide with twelve complete 40-minute team handball lessons for ages 8–11, plus 5 teaching resources. $27 USD one-time, with a 10-day money-back guarantee.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
    initMetaPixel();

    // ViewContent once, when the offer section first comes into view.
    const offer = document.getElementById('offer-details');
    if (!offer || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        trackPixel('ViewContent', OFFER_PIXEL_PARAMS);
        observer.disconnect();
      }
    }, {
      threshold: 0.25
    });
    observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="d4o09u01u88q">
      <div className="min-h-screen w-full overflow-x-clip bg-ink font-sans text-base text-white" data-id="element-1" data-mp="d3cujon1mqez">
        <a href="#main" className="sr-only bg-gold px-5 py-3 font-bold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70]" data-id="element-2" data-mp="86w6eufugc1w">
          Skip to content
        </a>
        <main id="main" data-id="element-3" data-mp="3bnus18yxo8ih">
          <Hero data-id="element-4" data-mp="3bkgs07dqsbe7" />
          <TrustStrip data-id="element-5" data-mp="3qaxtfqqdn1b3" />
          <Problems data-id="element-6" data-mp="3qc97cjdjdpfx" />
          <Solution data-id="element-7" data-mp="3qcr0h74wjnjm" />
          <CoreContent data-id="element-8" data-mp="3qdajysa7ajzr" />
          <InsidePreview data-id="element-9" data-mp="3lkr6rwffdqvh" />
          <Bonuses data-id="element-10" data-mp="3ljg2lvi2ih3u" />
          <Offer data-id="element-11" data-mp="3liwkadoi9qpa" />
          <Guarantee data-id="element-12" data-mp="3liedin47vu34" />
          <Faq data-id="element-13" data-mp="2xuwtjdr720ap" />
          <FinalComparison data-id="element-14" data-mp="2xud9nrhzh1u1" />
        </main>
        <Footer data-id="element-15" data-mp="2xtbw9gdhw395" />
        <StickyBar data-id="element-16" data-mp="2xssf41vo5iw6" />
      </div>
    </MotionConfig>;
}